import { api } from '@wellesley/openapi'
import { handleBasicResponse } from '@wellesley/openapi/helpers'
import { groupSlice } from '../slices/useGroupSlice'
import { toast } from '@wellesley/system-toast'
import { getErrorMsg } from '@wellesley/error-kit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react'

const rulesApi = api.enhanceEndpoints({
  endpoints: {
    getApiV1GroupsByGroupIdRules: {
      providesTags: ['GroupRules', 'USER_CHANGED'],
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const res = await handleBasicResponse(queryFulfilled)
          if (res) {
            dispatch(groupSlice.actions.setRules(res.data))
          }
        } catch (e) {
          toast.error(
            `Failed to fetch rules: ${getErrorMsg(e as FetchBaseQueryError)}`,
          )
        }
      },
    },
    postApiV1GroupsByGroupIdRules: {
      invalidatesTags: ['GroupRules'],
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const res = await handleBasicResponse(queryFulfilled, 'Rule created')
          if (res) {
            dispatch(groupSlice.actions.addRule(res.data))
          }
        } catch (e) {
          toast.error(
            `Failed to delete rule: ${getErrorMsg(e as FetchBaseQueryError)}`,
          )
        }
      },
    },
    deleteApiV1GroupsByGroupIdRulesAndId: {
      invalidatesTags: ['GroupRules'],
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
          await handleBasicResponse(queryFulfilled, 'Rule deleted')
          dispatch(groupSlice.actions.removeRule(args.id))
        } catch (e) {
          toast.error(
            `Failed to delete rule: ${getErrorMsg(e as FetchBaseQueryError)}`,
          )
        }
      },
    },
    putApiV1GroupsByGroupIdRulesAndRuleId: {
      invalidatesTags: ['GroupRules'],
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const res = await handleBasicResponse(queryFulfilled, 'Rule updated')
          if (res) {
            dispatch(groupSlice.actions.updateRule(res.data))
          }
        } catch (e) {
          toast.error(
            `Failed to update rule: ${getErrorMsg(e as FetchBaseQueryError)}`,
          )
        }
      },
    },
    postApiV1GroupsByGroupIdRulesReorder: {
      invalidatesTags: ['GroupRules'],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await handleBasicResponse(queryFulfilled, 'Rules reordered')
        } catch (e) {
          toast.error(
            `Failed to reorder rules: ${getErrorMsg(e as FetchBaseQueryError)}`,
          )
        }
      },
    },
  },
})

export const {
  useGetApiV1GroupsByGroupIdRulesQuery,
  usePostApiV1GroupsByGroupIdRulesMutation,
  usePutApiV1GroupsByGroupIdRulesAndRuleIdMutation,
  usePostApiV1GroupsByGroupIdRulesReorderMutation,
  useDeleteApiV1GroupsByGroupIdRulesAndIdMutation,
} = rulesApi
